/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2FyaWFkbmFlcmNpbGxhbW9udHNlcnJhdC9EZXNrdG9wL0ZFSU5BL3BvcnRmb2xpby9wb3J0Zm9saW9fYXJpL3NyYy9hcHAvcG9ydGZvbGlvLXNjaHdlcHBlcy9wb3J0Zm9saW8tc2Nod2VwcGVzLmNvbXBvbmVudC5zYXNzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2FyaWFkbmFlcmNpbGxhbW9udHNlcnJhdC9EZXNrdG9wL0ZFSU5BL3BvcnRmb2xpby9wb3J0Zm9saW9fYXJpL3NyYy9hcHAvcG9ydGZvbGlvLXNjaHdlcHBlcy9wb3J0Zm9saW8tc2Nod2VwcGVzLmNvbXBvbmVudC5zYXNzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/portfolio-schweppes/portfolio-schweppes.component.sass.shim.ngstyle.ts